import i18n from '@/dependencies/i18n';

const { t } = i18n.global;

export default {
    path: '/entity/:entityId',
    component: () => import('@/views/Client/ClientEntityView.vue'),
    meta: {
        private: true,
        breadcrumb: {
            parent: 'dashboard',
        },
    },
    children: [
        {
            path: '',
            name: 'entity',
            component: () => import('@/components/Client/Entity/Entity.vue'),
            meta: {
                breadcrumb() {
                    return {
                        label: t('SIDEBAR_MENU.OVERVIEW'),
                    };
                },
            },
        },
        {
            path: 'entity-documents',
            name: 'entity-documents',
            component: () => import('@/components/Client/Entity/views/EntityDocuments/EntityDocuments.vue'),
            meta: {
                breadcrumb: () => ({ label: t('SIDEBAR_MENU.DOCUMENTS') }),
            },
        },
        {
            path: 'entity-jobs',
            name: 'entity-jobs',
            component: () => import('@/components/Client/Entity/views/EntityJobs/EntityJobs.vue'),
            meta: {
                breadcrumb: () => ({ label: t('SIDEBAR_MENU.JOBS') }),
            },
        },
        {
            path: 'entity-permissions',
            name: 'entity-permissions',
            component: () => import('@/components/Client/Entity/views/EntityPermissions/EntityPermissions.vue'),
            meta: {
                accountTypes: ['support'],
                breadcrumb: () => ({ label: t('SIDEBAR_MENU.PERMISSIONS') }),
            },
        },
    ],
};
